import { render, staticRenderFns } from "./MdPatientMarsAlert.vue?vue&type=template&id=7839267f&"
import script from "./MdPatientMarsAlert.vue?vue&type=script&lang=js&"
export * from "./MdPatientMarsAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports